// client/src/index.js - Fixed imports

import Phaser from 'phaser';
import MainMenuScene from './scenes/MainMenuScene';
import CameraPermissionScene from './scenes/CameraPermissionScene';
import GameplayScene from './scenes/GameplayScene';

// Import CSS
import './assets/css/main.css';

// A simplified configuration to focus on core functionality
const config = {
    type: Phaser.AUTO,
    width: 800,
    height: 600,
    parent: 'game-container',
    backgroundColor: '#000000',
    scale: {
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_BOTH
    },
    // Only include the scenes we've properly implemented and tested
    scene: [
        MainMenuScene,
        CameraPermissionScene,
        GameplayScene
        // Other scenes will be added as they are fully implemented
    ],
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 },
            debug: false
        }
    },
    audio: {
        disableWebAudio: true,  // Use HTML5 Audio instead which has better compatibility
        noAudio: false          // Set to true if audio is causing problems
    }
};

// Initialize game with error handling
document.addEventListener('DOMContentLoaded', () => {
    try {
        // Create the game instance
        const game = new Phaser.Game(config);

        // Expose game to window for debugging
        window.game = game;

        console.log('Game initialized with scenes:',
            config.scene.map(scene => scene.name || 'Unnamed Scene').join(', '));
    } catch (error) {
        console.error('Failed to initialize game:', error);

        // Show error in DOM
        const gameContainer = document.getElementById('game-container');
        if (gameContainer) {
            gameContainer.innerHTML = `
        <div style="color: white; text-align: center; padding: 20px;">
          <h2>Failed to initialize game</h2>
          <p>${error.message || 'Unknown error'}</p>
          <button onclick="location.reload()">Try Again</button>
        </div>
      `;
        }
    }
});